(function(){
  function init(root){
    if (root.dataset.ppspecInit) return;
    root.dataset.ppspecInit = '1';

    var svg = root.querySelector('.ppspec__svg');
    var active = null;

    function paint(k){
      if (!svg) return;
      svg.classList.toggle('hl', !!k);
      svg.querySelectorAll('.dg').forEach(function(g){ g.classList.toggle('on', g.dataset.dim === k); });
      root.querySelectorAll('.ppspec__chip').forEach(function(c){ c.classList.toggle('on', c.dataset.k === k); });
    }

    root.querySelectorAll('.ppspec__chip').forEach(function(c){
      c.addEventListener('click', function(){
        active = (active === c.dataset.k) ? null : c.dataset.k;
        paint(active);
      });
      c.addEventListener('pointerenter', function(){ paint(c.dataset.k); });
      c.addEventListener('pointerleave', function(){ paint(active); });
    });

    if (svg) {
      svg.querySelectorAll('.dg').forEach(function(g){
        g.addEventListener('pointerenter', function(){ paint(g.dataset.dim); });
        g.addEventListener('pointerleave', function(){ paint(active); });
        g.addEventListener('click', function(){
          active = (active === g.dataset.dim) ? null : g.dataset.dim;
          paint(active);
        });
      });
    }

    root.querySelectorAll('.ppspec__seg button').forEach(function(btn){
      btn.addEventListener('click', function(){
        var u = btn.dataset.u;
        root.querySelectorAll('.ppspec__seg button').forEach(function(b){
          b.classList.toggle('on', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        root.querySelectorAll('[data-mm]').forEach(function(el){
          var mm = parseFloat(el.dataset.mm);
          if (isNaN(mm)) return;
          var v = (u === 'mm') ? el.dataset.mm : (mm / 25.4).toFixed(2);
          el.textContent = el.dataset.j ? (v + (u === 'mm' ? 'mm' : 'in')) : v;
        });
        root.querySelectorAll('.ppspec__chip-u').forEach(function(s){ s.textContent = (u === 'mm') ? 'mm' : 'in'; });
      });
    });

    /* サイズガイド弹窗：兜底开关（与既有主题 JS 重复绑定也安全） */
    var modal = document.getElementById('citron_size_myModal');
    var find = root.querySelector('.ppspec__find');
    if (modal && find){
      find.addEventListener('click', function(e){
        var a = e.target.closest('a');
        if (!a) return;
        e.preventDefault();
        modal.style.display = 'block';
      });
      var x = modal.querySelector('.close');
      if (x) x.addEventListener('click', function(){ modal.style.display = 'none'; });
      modal.addEventListener('click', function(e){ if (e.target === modal) modal.style.display = 'none'; });
    }
  }

  document.querySelectorAll('[data-ppspec]').forEach(init);
  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('[data-ppspec]');
    if (r) init(r);
  });
})();